import { forgotPasswordState } from '../state/forgotPasswordState'
import {
    ADD_COMPANY_REQUEST, APPLICATION_REQUEST, RESET_USER_PASSWORD_REQUEST, RESET_USER_PASSWORD_SUCCESS,
    RESET_USER_PASSWORD_ERROR, FETCH_USER_PASSWORD_REQUEST,
    RESET_USER_PASSWORD_REQUEST1, RESET_USER_PASSWORD_SUCCESS1,
    RESET_USER_PASSWORD_ERROR1, FETCH_USER_PASSWORD_REQUEST1,
    RESET_USER_PASSWORD_REQUEST2, RESET_USER_PASSWORD_SUCCESS2,
    RESET_USER_PASSWORD_ERROR2, FETCH_USER_PASSWORD_REQUEST2
} from '../actions/forgotPasswordAction'


export function forgotPasswordReducer(state = forgotPasswordState, action) {
    switch (action.type) {
        case ADD_COMPANY_REQUEST:

            return Object.assign({}, state, {
                errorCode: action.errorCode,
                statusCode: action.statusCode,
                isLoading: false,
                Message: 'Success',
                brandList: action.brandList
            })
        case APPLICATION_REQUEST:
            return Object.assign({}, state, {
                errorCode: 0,
                statusCode: 0,
                isLoading: action.isLoading,
                Message: ''
            })
        case RESET_USER_PASSWORD_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                errorMessage: '',
                statusCode: '',
            })
        case FETCH_USER_PASSWORD_REQUEST:
            return Object.assign({}, state, {
                isLoading: false,
                errorMessage: '',
                statusCode: '',
            })
        case RESET_USER_PASSWORD_SUCCESS:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                errorMessage: action.errorMessage,
                statusCode: action.statusCode,
            })
        case RESET_USER_PASSWORD_ERROR1:

            return Object.assign({}, state, {
                isLoading: action.isLoading,

                statusCode: action.statusCode,
                errorCode: action.errorCode,
                errorMessage: action.errorMessage,


            })
            case RESET_USER_PASSWORD_REQUEST1:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                
                errorMessage: '',
                statusCode: '',
            })
        case FETCH_USER_PASSWORD_REQUEST1:
            return Object.assign({}, state, {
                isLoading: false,
                errorMessage: '',
                statusCode: '',
            })
        case RESET_USER_PASSWORD_SUCCESS1:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                requestForgotPasswordDetail:action.requestForgotPasswordDetail,
                errorMessage: action.errorMessage,
                statusCode: action.statusCode,
            })
        case RESET_USER_PASSWORD_ERROR1:

            return Object.assign({}, state, {
                isLoading: action.isLoading,

                statusCode: action.statusCode,
                errorCode: action.errorCode,
                errorMessage: action.errorMessage,


            })

             case RESET_USER_PASSWORD_ERROR1:

            return Object.assign({}, state, {
                isLoading: action.isLoading,

                statusCode: action.statusCode,
                errorCode: action.errorCode,
                errorMessage: action.errorMessage,


            })
            case RESET_USER_PASSWORD_REQUEST2:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                
                errorMessage: '',
                verifyStatusCode: '',
            })
        case FETCH_USER_PASSWORD_REQUEST2:
            return Object.assign({}, state, {
                isLoading: false,
                errorMessage: '',
                verifyStatusCode: '',
            })
        case RESET_USER_PASSWORD_SUCCESS2:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                errorMessage: action.errorMessage,
                verifyStatusCode: action.statusCode,
            })
        case RESET_USER_PASSWORD_ERROR2:

            return Object.assign({}, state, {
                isLoading: action.isLoading,

                verifyStatusCode: action.statusCode,
                errorCode: action.errorCode,
                errorMessage: action.errorMessage,


            })

        default:
            return state;
    }
} 
